export const LANGUAGE_ABBREVIATIONS = {
  LT: 'lt',
  RU: 'ru',
  EN: 'en',
};
